// Loads all the decoded original game assets (PNG files in /assets)
const SCR = [
  "mifne", "credits", "intro", "newday", "goodwthr", "badwthr", "mainscrn",
  "help", "socher", "expand", "thieves", "crew", "wheatup", "wheatdn",
  "olivesup", "olivesdn", "copperup", "copperdn", "fishing", "in_10", "first_10",
];
const WIN = [
  "map", "stay", "repair", "deserted", "damaged", "night", "overwght",
  "guards", "pirates", "confront", "runaway", "offer", "change", "sinking",
  "storm", "sirton", "strike", "arafel", "bank", "buyturk", "buyisr",
  "buyegpt", "sellturk", "sellisr", "sellegpt",
];
const SGN = ["buy", "sell", "withrow", "deposit", "message", "pirates", "score",
  "day1", "day2", "day3", "day4", "day5", "day6", "day7"];
const LIN = ["line_6"];

async function loadImage(src) {
  const res = await fetch(src);
  if (!res.ok) throw new Error(`failed to load ${src} (${res.status})`);
  const blob = await res.blob();
  if (typeof createImageBitmap === "function") {
    return await createImageBitmap(blob);
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`failed to decode ${src}`));
    img.src = url;
  });
}

export async function loadAssets(onProgress) {
  const entries = [];
  for (const n of SCR) entries.push([`${n}_scr`, `/assets/${n}_scr.png`]);
  for (const n of WIN) entries.push([`${n}_win`, `/assets/${n}_win.png`]);
  for (const n of SGN) entries.push([`${n}_sgn`, `/assets/${n}_sgn.png`]);
  for (const n of LIN) entries.push([`${n}_lin`, `/assets/${n}_lin.png`]);
  let done = 0;
  const images = await Promise.all(
    entries.map(([key, src]) =>
      loadImage(src).then((img) => {
        done += 1;
        if (onProgress) onProgress(done, entries.length, key);
        return img;
      })
    )
  );
  const assets = {};
  entries.forEach(([key], i) => {
    assets[key] = images[i];
  });
  return assets;
}
